import React from "react";
import { globalApplicationServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const GlobalApplicationServiceDetailPage = () => {
  const data = globalApplicationServiceData;
  return (
    <>
      <SEO {...seoData.globalApplications} />
      <ServiceDetailsInner data={data} />
    </>
  );
};

export default GlobalApplicationServiceDetailPage;
